import { useEffect, useState, useContext } from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import Axios from 'axios';
import { useNavigate } from 'react-router'; 
// @mui
import Box from '@mui/material/Box';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import IconButton from '@mui/material/IconButton';
// auth
import { useAuthContext } from 'src/auth/hooks';
// components
import Iconify from 'src/components/iconify';
import CustomPopover, { usePopover } from 'src/components/custom-popover';

// ----------------------------------------------------------------------

export default function Support() {

  const { user } = useAuthContext();

  const popover = usePopover();


  const handleHelp = () => {
    const subject = encodeURIComponent("");
    const body = encodeURIComponent(
      "Bonjour l’équipe Postgrad, \n\n"
    );
  
    window.location.href = `mailto:contact@postgrad.fr?subject=${subject}&body=${body}`;
  };

  return (
     <Box display="flex" justifyContent="end" sx={{ mb: 3 }}>
      <Tooltip title="Besoin d'aide ?">
        <IconButton color={popover.open ? 'inherit' : 'default'} onClick={()=>handleHelp()}>
          <Iconify icon="solar:question-circle-linear" />
        </IconButton>
      </Tooltip>

        <CustomPopover
          open={popover.open}
          onClose={popover.onClose}
          arrow="right-top"
          sx={{ width: 240 }}
        >

          <MenuItem onClick={()=>{handleHelp(); popover.onClose();}}>
            contacter le support 
          </MenuItem>

        </CustomPopover>
    </Box>
  );
}

/*    <Tooltip title="Besoin d'aide ?">
        <IconButton color={popover.open ? 'inherit' : 'default'} onClick={popover.onOpen}>
          <Iconify icon="solar:question-circle-linear" />
        </IconButton>
      </Tooltip>
 */

